import React from "react"
import {FieldFormElementViewProps} from "../../../../render/form-elemnent-view"
import RadioGroupStateless from "./components/radio-group-stateless"

export default function FieldRadioGroup_FormElementView(props: FieldFormElementViewProps) {

    const value = props.model[props.field.fieldId]

    return <RadioGroupStateless className       = {props.className}
                                options         = {props.field.getOptions()}
                                selectedValue   = {value}
                                onChange        = {props.onChange}/>

}